import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { FirmwareOverviewDto } from '../../../features/firmware-management/dtos/firmware-overview.dto';
import { FirmwareHeaderAndPaginationFilters } from '../../../features/firmware-management/models/firmware-header-and-pagination-filters.model';
import { mapFirmwareOverviewDtoToFirmwareOverviewModel } from '../../../features/firmware-management/utils/mapping/mapping.util';
import { axiosInstance } from '../../../features/shared/api/axios-instance';
import { createQueryParams } from '../../../features/shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../../features/shared/utils/endpoints-file.utils';
import { FirmwareOverviewModel } from '../../models/firmware-overview.model';
import { PaginationDefaults } from '../../utils/pagination-defaults.util';
import { withMandant } from '../with-mandant/with-mandant.thunk';

export const getFirmwaresWithPagination: AsyncThunk<
  FirmwareOverviewModel[],
  Partial<FirmwareHeaderAndPaginationFilters> | undefined,
  Record<string, unknown>
> = withMandant<
  Partial<FirmwareHeaderAndPaginationFilters> | undefined,
  FirmwareOverviewModel[]
>(
  Endpoints.FIRMWARE_BY_MANDANT_ID,
  'firmware/get-firmwares-with-pagination',

  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      ...args?.header,
      size: args?.pagination?.size
        ? args.pagination.size
        : PaginationDefaults.size,
      offset: args?.pagination?.offset
        ? args.pagination.offset
        : PaginationDefaults.offset,
    });

    const { data }: AxiosResponse<FirmwareOverviewDto[]> =
      await axiosInstance.get(endpoint + queryParams);

    return data.map(mapFirmwareOverviewDtoToFirmwareOverviewModel);
  }
);
